import { extendTheme } from "@chakra-ui/react";

/**
 * Shared mobile defaults: no horizontal page scroll, touch-friendly base font.
 */
const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        maxWidth: "100%",
        overflowX: "hidden",
      },
      body: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        WebkitTapHighlightColor: "transparent",
      },
      "#root": {
        minHeight: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        _focusVisible: {
          boxShadow: "outline",
        },
      },
    },
  },
});

export default theme;
